/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ApiConfig} from '../config/api-config';
import {AdnApiClientService} from '../common/controller/adn-api-client.service';

export interface CreativeSetInfoModel {
  id: string;
  [key: string]: any;
}

export function creativeSetBreadcrumbData(
  creativeSet: any,
  info: any = {},
  fallback: {advertiser?: any; folio?: any} = {}
): {creativeSet: any; advertiser: any; folio: any} {
  const folio = info.folio || creativeSet?.folio || fallback.folio;
  return {
    creativeSet,
    folio,
    advertiser: info.advertiser || folio?.advertiser || creativeSet?.advertiser || fallback.advertiser
  };
}

@Injectable({providedIn: 'root'})
export class CreativeSetInfoApiService {
  private readonly uri = this.apiConfig.getVersionedUri('creativesets/info');

  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  get(id: string): Observable<CreativeSetInfoModel> {
    return this.client.request<CreativeSetInfoModel>({
      method: 'GET',
      url: this.uri + '/' + encodeURIComponent(id)
    });
  }
}
